import * as EventQueries from 'queries/event';
import { makeApolloClient, logError, emitWithAck, socketDisconnectedError } from '../util';
import {
	FETCH_EVENTS,
	FETCH_EVENT,
	FETCH_EVENTS_INC_DEL,
	UPDATE_EVENT,
	ADD_EVENT,
	DELETE_EVENT,
	UNDELETE_EVENT,
} from './actionTypes';
import { setAdmin } from './admin.action';

export const undeleteEvent = event => ({
	type: UNDELETE_EVENT,
	event,
});

export const updateEvent = event => ({
	type: UPDATE_EVENT,
	event,
});

export const deleteEvent = event => ({
	type: DELETE_EVENT,
	event,
});

export const addEvent = event => ({
	type: ADD_EVENT,
	event,
});

const updateSignedInAdminEvents = (dispatch, getState, nextEvents) => {
	const { auth, admins } = getState();
	const email = auth.adminSSOProfile?.email;
	const admin = admins[email];
	if (!admin?.events) return;
	const events = nextEvents(admin);
	if (events !== admin.events) dispatch(setAdmin({ ...admin, events }, email));
};

export const recordCreatedEvent = event => (dispatch, getState) => {
	const isNew = !getState().events.events[event.id];
	dispatch(addEvent(event));
	updateSignedInAdminEvents(dispatch, getState, admin => {
		const isMine = event.owner_id === admin.id;
		const isListed = admin.events.some(evt => evt.id === event.id);
		return isMine && !isListed ? [...admin.events, event] : admin.events;
	});
	return isNew;
};

export const recordDeletedEvent = event => (dispatch, getState) => {
	dispatch(deleteEvent(event));
	updateSignedInAdminEvents(dispatch, getState, admin =>
		admin.events.filter(evt => evt.id !== event.id)
	);
};

const fetchEvents = (events, from = '') => ({
	type: FETCH_EVENTS,
	events,
	from,
});

export const thunkFetchEvents = (clientID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { events } = await client.request(EventQueries.EVENTS, {
			client_id: clientID,
		});
		if (from !== 'EventPicker') dispatch(fetchEvents(events, from));
		else return events;
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEvents');
	}
};

const fetchEvent = (event, from = '') => ({
	type: FETCH_EVENT,
	event,
	from,
});

export const thunkFetchEvent = (eventID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { event } = await client.request(EventQueries.EVENT, {
			id: eventID,
		});
		dispatch(fetchEvent(event, from));
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEvent');
		dispatch(fetchEvent({ id: eventID, deleted_at: true }, from));
	}
};

const fetchEventsIncDel = (eventsIncDel, from = '') => ({
	type: FETCH_EVENTS_INC_DEL,
	eventsIncDel,
	from,
});

export const thunkFetchEventsIncDel = (clientID, from) => async (dispatch, getState) => {
	const client = makeApolloClient(getState());
	try {
		const { eventsIncludingDeleted } = await client.request(EventQueries.EVENTS_INCLUDING_DELETED, {
			client_id: clientID,
		});
		dispatch(fetchEventsIncDel(eventsIncludingDeleted, from));
	} catch (error) {
		logError(error, 'event.actions.thunkFetchEventsIncDel');
	}
};

export const CREATE_EVENT_ACK_TIMEOUT_MS = 20000;

export const assertSocketConnected = () => (dispatch, getState) => {
	if (!getState().ws.socket.connected) throw socketDisconnectedError('event/POST');
};

export const thunkCreateEvent = (eventInput, widgets) => async (dispatch, getState) => {
	const { ws, auth } = getState();
	const created = await emitWithAck(
		ws.socket,
		CREATE_EVENT_ACK_TIMEOUT_MS,
		'event/POST',
		eventInput,
		auth.adminSSOProfile.email,
		auth.auth0Token,
		widgets
	);
	dispatch(recordCreatedEvent(created));
	return created;
};
